export default {
  // ── fans/page.tsx ──
  'fans.hero.title': 'VOICES OF IMPACT',
  'fans.hero.subtitle': 'REAL PEOPLE. REAL STORIES. A GLOBAL IMPACT.',
  'fans.hero.body': "Behind every headline are people whose lives have been influenced by Andrew and Tristan Tate's messages about discipline, responsibility, physical strength, family, faith, resilience, and personal improvement. These are their words.",
  'fans.hero.disclaimer': 'Testimonials reflect the personal opinions and experiences of their respective authors. Tate Protest does not independently verify every statement or claim.',
  'fans.hero.imgAlt': 'Global supporters united in solidarity',
  'fans.hero.imgTitle': 'Voices of Impact – Global Tate Supporters in Solidarity',

  'fans.seo.title': 'Voices of Impact | Tate Supporter Testimonials | Tate Protest',
  'fans.seo.description': 'Read personal stories from people who credit Andrew and Tristan Tate with influencing their discipline, fitness, mental resilience, business, faith, family relationships, and sense of purpose.',
  'fans.seo.keywords': 'Tate supporter testimonials, voices of impact, Andrew Tate fan stories, Tristan Tate impact, Tate Protest community, personal transformation, discipline, fitness, faith',
  'fans.seo.aboutName': 'Tate Brothers Supporter Testimonials',
  'fans.seo.aboutDescription': 'A collection of first-person accounts from individuals describing the impact of Andrew and Tristan Tate on their lives.',

  'fans.allTestimonials.label': 'ALL TESTIMONIALS',
  'fans.allTestimonials.body': 'Browse the complete collection of supporter stories. Use the filters to explore by theme.',

  // ── CommunityVoicesSection ──
  'fans.community.label': 'COMMUNITY VOICES',
  'fans.community.body': 'A selection of voices from supporters across the community.',

  // ── FeaturedStories ──
  'fans.featured.label': 'FEATURED TRANSFORMATION STORIES',
  'fans.featured.body': "Detailed personal accounts of how Andrew and Tristan Tate's message inspired meaningful change.",
  'fans.featured.readFull': 'READ FULL TESTIMONIAL',
  'fans.featured.collapse': 'COLLAPSE',
  'fans.featured.ariaExpand': 'Read full testimonial',
  'fans.featured.ariaCollapse': 'Collapse testimonial',
  'fans.featured.defaultLabel': 'PERSONAL STORY',

  // ── FilterBar ──
  'fans.filter.all': 'ALL STORIES',
  'fans.filter.discipline': 'DISCIPLINE',
  'fans.filter.mentalHealth': 'MENTAL HEALTH',
  'fans.filter.fitness': 'FITNESS',
  'fans.filter.business': 'BUSINESS',
  'fans.filter.family': 'FAMILY',
  'fans.filter.faith': 'FAITH',
  'fans.filter.dueProcess': 'DUE PROCESS',

  // ── FinalCTA ──
  'fans.finalCta.title': 'THE IMPACT CANNOT BE REDUCED TO A HEADLINE',
  'fans.finalCta.body': "Public figures are often judged through isolated clips, accusations, and controversy. These testimonials document a different part of the story: the people who credit Andrew and Tristan Tate with encouraging discipline, responsibility, resilience, faith, physical improvement, and personal ambition.",
  'fans.finalCta.readTateStory': 'READ THE TATE STORY',
  'fans.finalCta.exploreLegal': 'EXPLORE THE LEGAL CASES',
  'fans.finalCta.signPetition': 'SIGN THE PETITION',

  // ── GlobalImpact ──
  'fans.globalImpact.title': 'IMPACT BEYOND HEADLINES',
  'fans.globalImpact.body': 'The individuals represented here describe changes involving discipline, physical health, mental resilience, business, faith, family relationships, and a renewed sense of purpose.',
  'fans.globalImpact.discipline': 'DISCIPLINE',
  'fans.globalImpact.mentalResilience': 'MENTAL RESILIENCE',
  'fans.globalImpact.fitness': 'FITNESS',
  'fans.globalImpact.business': 'BUSINESS',
  'fans.globalImpact.family': 'FAMILY',
  'fans.globalImpact.faith': 'FAITH',

  // ── LegalDisclaimer ──
  'fans.legal.title': 'LEGAL AND EDITORIAL DISCLAIMER',
  'fans.legal.p1': 'The testimonials published on this page reflect the individual opinions and reported experiences of their respective authors. Publication does not establish that every factual statement has been independently verified by Tate Protest. Testimonials are presented for public-interest, advocacy, and informational purposes and do not constitute legal testimony or evidence.',
  'fans.legal.p2': 'Testimonials reflect the personal opinions and experiences of their respective authors. Tate Protest does not independently verify every statement or claim. Names are displayed as published publicly on Change.org or as submitted by the authors.',

  // ── ShortStatements ──
  'fans.shortStatements.label': 'SHORT STATEMENTS',
  'fans.shortStatements.ariaPrev': 'Previous statements',
  'fans.shortStatements.ariaNext': 'Next statements',

  // ── SubmitTestimonial ──
  'fans.submit.title': 'SHARE THE IMPACT',
  'fans.submit.body': "Supporters may submit their own accounts of how Andrew or Tristan Tate's content, businesses, teachings, or legal experience affected their lives and perspectives.",
  'fans.submit.btn': 'SUBMIT A TESTIMONIAL',
  'fans.submit.successTitle': 'Thank You',
  'fans.submit.successBody': 'Your testimonial has been received. It will be reviewed before publication.',
  'fans.submit.labelName': 'Display Name or Initials *',
  'fans.submit.placeholderName': 'e.g. John D.',
  'fans.submit.labelTestimonial': 'Your Testimonial *',
  'fans.submit.placeholderTestimonial': 'Share your experience...',
  'fans.submit.labelCountry': 'Country (Optional)',
  'fans.submit.placeholderCountry': 'e.g. United States',
  'fans.submit.labelCategory': 'Impact Category (Optional)',
  'fans.submit.selectCategory': 'Select a category',
  'fans.submit.categoryOther': 'Other',
  'fans.submit.checkGenuine': 'I confirm that this submission reflects my genuine personal experience.',
  'fans.submit.checkPermission': 'I authorize Tate Protest to publish this testimonial using the displayed name or initials provided.',
  'fans.submit.submitBtn': 'SUBMIT TESTIMONIAL',
  'fans.submit.cancel': 'Cancel',
  'fans.submit.errorConnection': 'Unable to submit. Please check your connection and try again.',

  // ── TestimonialGrid ──
  'fans.grid.empty': 'No testimonials found for this category.',

  // ── donate/page.tsx ──
  'donate.hero.titleSuccess': 'THANK YOU',
  'donate.hero.titleDefault': 'SUPPORT THE FIGHT',
  'donate.hero.subtitleSuccess': 'Your support makes a difference',
  'donate.hero.subtitleDefault': 'Help us organize, document, and inform',
  'donate.hero.imgAlt': 'Dark cinematic abstract background',

  'donate.success.title': 'THANK YOU FOR SUPPORTING TATE PROTEST',
  'donate.success.body': "Your contribution helps Tate Protest continue its independent work promoting transparency, due process, and lawful peaceful advocacy.",
  'donate.success.shareTateProtest': 'SHARE TATE PROTEST',
  'donate.success.signPetition': 'SIGN THE PETITION',
  'donate.success.returnHome': 'RETURN HOME',
  'donate.success.shareText': 'I just supported Tate Protest — an independent platform promoting transparency and due process. Learn more:',

  'donate.form.sectionTitle': 'HELP US ORGANIZE, DOCUMENT, AND INFORM',
  'donate.form.sectionBody': 'Your contribution supports lawful event coordination, public-information research, outreach materials, website operations, and the technology required to keep supporters informed.',
  'donate.form.noticeBody': 'Every contribution—large or small—helps Tate Protest continue its independent advocacy for transparency, due process, and fair legal proceedings.',

  'donate.method.choose': 'Choose a contribution method',
  'donate.method.cardTitle': 'Card',
  'donate.method.cardDescription': 'One-time or monthly contribution via Stripe.',
  'donate.method.cryptoTitle': 'USDT on Solana',
  'donate.method.cryptoDescription': 'Send a direct wallet transfer. No wallet connection required.',
  'donate.crypto.token': 'Token · USDT',
  'donate.crypto.network': 'Network · Solana',
  'donate.crypto.title': 'Send USDT directly',
  'donate.crypto.intro': 'Use your wallet or exchange withdrawal screen to transfer USDT to the address below.',
  'donate.crypto.recipientLabel': 'Recipient wallet address',
  'donate.crypto.viewExplorer': 'View on Solscan',
  'donate.crypto.addressAccessibleLabel': 'Full USDT recipient address on Solana',
  'donate.crypto.copyAddress': 'Copy address',
  'donate.crypto.copySuccess': 'Address copied. Confirm the token, network, and full address in your wallet before sending.',
  'donate.crypto.copyError': 'Could not copy automatically. Select the full address above and copy it manually.',
  'donate.crypto.manualCopy': 'Copy unavailable? Select the full address above, then copy it manually.',
  'donate.crypto.stepsTitle': 'Transfer steps',
  'donate.crypto.step1': 'Open your wallet or exchange and choose to send or withdraw USDT.',
  'donate.crypto.step2': 'Select the Solana network, then paste the recipient address above.',
  'donate.crypto.step3': 'Confirm USDT, Solana, and the complete recipient address before approving the transfer.',
  'donate.crypto.networkWarning': 'Send ONLY USDT via Solana. Do not use Ethereum, TRON, or any other network.',
  'donate.crypto.irreversible': 'Transfers are irreversible. Your wallet may require SOL to pay Solana network fees.',
  'donate.crypto.directTransfer': 'This is a direct wallet transfer. The site does not automatically confirm receipt or issue a receipt.',

  'donate.priority.label': 'CURRENT PRIORITY',
  'donate.priority.title': 'NEXT COURT DATE: UNKNOWN',
  'donate.priority.body': 'Support ongoing public-information research, communications, outreach, and case updates while no new court date has been announced.',

  'donate.largeContrib.title': 'PLANNING A LARGE CONTRIBUTION?',
  'donate.largeContrib.body': 'For contributions of $2,500 or more, contact Tate Protest to complete identity verification and discuss approved payment arrangements.',
  'donate.largeContrib.btn': 'CONTACT CONTRIBUTIONS TEAM',
  'donate.largeContrib.warning': 'Never send banking or financial information through an unverified email, social-media account, or direct message.',

  'donate.sidebar.howUsedTitle': 'How Contributions May Be Used',
  'donate.sidebar.howUsedFootnote': 'These examples illustrate possible uses of contributions. Actual expenses depend on current operational and campaign needs.',

  'donate.sidebar.howUsed.25.title': 'Outreach Materials',
  'donate.sidebar.howUsed.25.desc': 'Helps support printed and digital public-information materials.',
  'donate.sidebar.howUsed.50.title': 'Demonstration Supplies',
  'donate.sidebar.howUsed.50.desc': 'Helps provide signs, banners, water, identification materials, and peaceful-event supplies.',
  'donate.sidebar.howUsed.100.title': 'Research and Communications',
  'donate.sidebar.howUsed.100.desc': 'Supports public-record research, case documentation, website operations, and supporter communications.',
  'donate.sidebar.howUsed.500.title': 'Event Coordination',
  'donate.sidebar.howUsed.500.desc': 'Contributes toward lawful event logistics, equipment, permits when required, and coordinated public outreach.',

  'donate.sidebar.secureTitle': 'Secure Payment Processing',
  'donate.sidebar.secure1': 'Payments are securely processed through Stripe',
  'donate.sidebar.secure2': 'Tate Protest does not directly receive or store complete card information',
  'donate.sidebar.secure3': 'Standard payment-processing fees may be deducted from contributions',

  'donate.sidebar.transparencyTitle': 'Contribution Transparency',
  'donate.sidebar.recipient.label': 'Recipient: Tate protest',
  'donate.sidebar.useOfFunds.label': 'Use of Funds',
  'donate.sidebar.useOfFunds.value': "Contributions support Tate Protest's independent advocacy, communications, research, website operations, outreach, and lawful event coordination.",
  'donate.sidebar.affiliation.label': 'Affiliation',
  'donate.sidebar.affiliation.value': 'Contributions are not paid to Andrew Tate, Tristan Tate, their families, attorneys, or legal defense unless expressly and publicly disclosed.',
  'donate.sidebar.processing.label': 'Processing',
  'donate.sidebar.processing.value': 'Payments are processed by Stripe and may be subject to standard processing fees.',

  'donate.sidebar.questions': 'Have questions about contributing?',
  'donate.sidebar.contactUs': 'Contact us',
  'donate.sidebar.questionsEnd': "and we'll get back to you within 24 hours.",

  'donate.transparency.title': 'TRANSPARENCY IN ACTION',
  'donate.transparency.body': 'Tate Protest is committed to showing supporters how contributions help advance peaceful advocacy, public research, outreach, and event coordination.',
  'donate.transparency.campaignGoal': 'CAMPAIGN GOAL',
  'donate.transparency.amountRaised': 'AMOUNT RAISED',
  'donate.transparency.eventExpenses': 'EVENT EXPENSES',
  'donate.transparency.completedInitiatives': 'COMPLETED INITIATIVES',
  'donate.transparency.photosResults': 'PHOTOS / RESULTS',
  'donate.transparency.pending': 'Campaign reporting will be published as verified figures become available.',

  // ── DonationForm ──
  'donate.donationForm.terminal': 'secure donation terminal',
  'donate.donationForm.cancelledMsg': 'Your contribution was not completed. If you ran into any issues, please try again or',
  'donate.donationForm.cancelledContact': 'contact us',
  'donate.donationForm.oneTime': 'One-Time',
  'donate.donationForm.monthly': 'Monthly',
  'donate.donationForm.monthlyNote': 'Recurring monthly contribution — cancel anytime',
  'donate.donationForm.selectAmount': '> select_contribution_amount',
  'donate.donationForm.other': '> OTHER',
  'donate.donationForm.enterAmount': 'Enter amount',
  'donate.donationForm.nameLabel': '> name',
  'donate.donationForm.nameOptional': '// optional',
  'donate.donationForm.namePlaceholder': 'Your name',
  'donate.donationForm.emailLabel': '> email',
  'donate.donationForm.emailOptional': '// optional',
  'donate.donationForm.emailPlaceholder': 'you@example.com',
  'donate.donationForm.messageLabel': '> message_of_support',
  'donate.donationForm.messageOptional': '// optional',
  'donate.donationForm.messagePlaceholder': 'Why this cause matters to you...',
  'donate.donationForm.redirecting': 'redirecting_to_payment...',
  'donate.donationForm.contributeBtn': '> CONTRIBUTE {{amount}} SECURELY',
  'donate.donationForm.securityNote': '// secure payment processing // powered by stripe',
  'donate.donationForm.errorDefault': 'Something went wrong. Please try again.',
};
